import { render } from "./topUp.vue?vue&type=template&id=a4c866b8&scoped=true"
import script from "./topUp.vue?vue&type=script&lang=js"
export * from "./topUp.vue?vue&type=script&lang=js"

import "./topUp.vue?vue&type=style&index=0&id=a4c866b8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4c866b8"]])

export default __exports__